import { Injectable, NgZone, effect, inject, signal } from '@angular/core';
import { NotificationService } from '../../api/services';
import { AuthService } from '../../guards/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationSignalService {
  private readonly INTERVAL = 60000; //60000
  unreadNotifications = signal<number>(0);
  polling?: NodeJS.Timeout;

  constructor(
    private notificationService: NotificationService, 
  ) {
    // effect(() => {
    //   //this.start();
    //   console.log(this.unreadNotifications());
    // });
  }

  start() {
    this.refresh();
    if (!this.polling) {
      const ngZone = inject(NgZone);
      ngZone.runOutsideAngular(() => {
        this.polling = setInterval(() => {
          this.fetchUnreadNotifications();
        }, this.INTERVAL);
      });
    }
  }

  stop() {
    this.unreadNotifications.set(0);
    clearInterval(this.polling);
    this.polling = undefined;
  }

  refresh() {
    //this.fetchUnreadNotifications();
  }

  fetchUnreadNotifications() {
    
      this.notificationService
      .notificationControllerCountMyNotifications()
      .subscribe({
        next: (res) => {
          this.unreadNotifications.set(res.data.count);
        },
      });
    
  }

}
